<script setup>
import { ref, defineProps } from 'vue'

const mediaURL = ref(process.env.VUE_APP_MEDIA_URL)

const props = defineProps({
  client_stats: {
    type: Array,
    default: () => [],
  },
  process: {
    type: Array,
    default: () => [],
  },
  photo: {
    type: String,
    default: '',
  },
  header: {
    type: String,
    default: '',
  },
  header_subtext: {
    type: String,
    default: '',
  },
  section_header: {
    type: String,
    default: '',
  },
  section_subtext: {
    type: String,
    default: '',
  },
  hero_img: {
    type: String,
    default: '',
  },
  hero_header: {
    type: String,
    default: '',
  },
  hero_button: {
    type: String,
    default: '',
  },
  hero_paragraph: {
    type: String,
    default: '',
  },
})
</script>
<template>
  <section class="container">
    <div
      class="p-mt-5 d-grid gap-10 p-justify-between"
      style="grid-template-columns: 1fr 488px"
    >
      <div class="w-100 image-wrapper">
        <img class="w-100 box-shadow" :src="`${props.hero_img}`" alt="" />
      </div>
      <div class="card-wrapper box-shadow">
        <h3 class="m-0">{{ props.hero_header }}</h3>
        <p class="m-0">
          {{ props.hero_paragraph }}
        </p>
        <router-link :to="{ name: 'getStarted' }" class="w-100">
          <Button class="choose-button w-100" :label="`${props.hero_button}`" />
        </router-link>
      </div>
    </div>
  </section>
  <div class="relative" style="margin-top: 80px">
    <div class="client-wrapper">
      <div class="overlays p-overflow-hidden">
        <img class="icon circles" src="/img/circle.svg" alt="star" />
      </div>
      <div
        class="relative container d-grid grid-columns-4 gap-6 h-100"
        style="place-items: center"
      >
        <img
          class="icon succlent"
          src="/img/succlent.png"
          width="100"
          height="100"
          alt="succlent"
        />
        <img
          class="icon bell-angle"
          src="/img/bell-angle.png"
          width="110"
          height="110"
          alt="bell angle"
        />
        <div
          class="d-flex p-flex-column text-white text-center stats-wrapper"
          v-for="stat in props.client_stats"
          :key="stat"
        >
          <h3 class="m-0">{{ stat.html_header }}</h3>
          <p class="m-0">{{ stat.html_body }}</p>
        </div>
      </div>
    </div>
  </div>
  <section class="container" style="margin-top: 80px">
    <div
      class="p-mt-4 grid-columns-2 gap-8 d-grid p-justify-center"
      style="grid-template-columns: 498px 616px"
    >
      <div class="w-100 image-wrapper">
        <img class="w-100" :src="`${props.photo}`" />
      </div>
      <div class="section">
        <h3 class="m-0">{{ props.section_header }}</h3>
        <p class="m-0">
          {{ props.section_subtext }}
        </p>
        <ul class="p-mt-4 p-0 d-flex p-flex-column gap-6">
          <li v-for="item in props.process" :key="item" class="d-flex gap-6">
            <div class="list-icon">
              <img :src="`${mediaURL}${item.file_path}`" />
            </div>
            <div>
              <h4>{{ item.html_header }}</h4>
              <p class="fw-400">
                {{ item.html_body }}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
<style lang="scss" scoped>
.section {
  h3 {
    font-size: 40px;
    font-weight: 600;
    color: rgba(35, 35, 35, 1);
  }
  p {
    font-size: 18px;
    font-weight: 500;
    color: rgba(35, 35, 35, 1);
  }
  h4 {
    font-size: 20px;
    font-weight: 600;
    color: rgba(35, 35, 35, 1);
  }
}
.list-icon {
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  flex-shrink: 0;
  background-color: #ffebcc;
}
.card-wrapper {
  display: flex;
  gap: 15px;
  flex-direction: column;
  background-color: #015cac;
  border-radius: 20px;
  padding: 40px;
  height: 100%;

  h3 {
    font-size: 36px;
    font-weight: 700;
    color: #fff;
  }
  p {
    font-size: 20px;
    font-weight: 400;
    color: #fff;
  }
}
.choose-button {
  border-radius: 6px;
  background: #fc6c2a !important;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  border: 1px solid #fc6c2a !important;
  transition: all 320ms;

  &:hover {
    background: #fff !important;
    color: #fc6c2a;
  }
  &:disabled {
    color: #fff !important;
    opacity: 0.5;
  }
}
.image-wrapper {
  border-radius: 20px;
  overflow: hidden;
}
.box-shadow {
  box-shadow: 0px 8px 8px -4px rgba(17, 24, 39, 0.04);
  box-shadow: 0px 20px 24px -4px rgba(17, 24, 39, 0.1);
}
.client-wrapper {
  position: relative;
  height: 230px;
  z-index: 99;

  .overlays {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #015cac;
    z-index: -1;
  }
}

.stats-wrapper {
  h3 {
    font-size: 65px;
    font-weight: 600;
  }
  p {
    font-size: 22px;
  }
}

.icon {
  position: absolute;

  &.succlent {
    top: calc(100% - 50px);
    left: 80px;
  }
  &.bell-angle {
    bottom: calc(100% - 52px);
    right: 90px;
  }
  &.circles {
    bottom: 0;
    right: 0;
  }
}
</style>
